export default __webpack_public_path__ + "static/john-goncalves-wjar-ri-01-dem-congressional-primary-debate-2-8526343a8b2771a38d504d64a33e24d2.webp";